import useApi from '@/hooks/useApi';
import useInertiaData from '@/hooks/useInertiaData';
import React, { useEffect } from 'react';
import BetaFeedbackWidget from '@/components/BetaFeedbackWidget';
import { Header, Sidebar } from './partials';

interface AppLayoutProps {
    children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
    const { user } = useInertiaData();
    const api = useApi();

    useEffect(() => {
        if (!user) {
            return;
        }

        const detectedTimezone =
            Intl.DateTimeFormat().resolvedOptions().timeZone;

        console.log('detectedTimezone', detectedTimezone);

        if (user.timezone !== detectedTimezone) {
            api.post('/api/update-timezone/', {
                timezone: detectedTimezone,
            }).catch((error) => {
                console.error('Failed to update timezone:', error);
            });
        }
    }, [user?.timezone, user, api]);

    return (
        <div className="flex min-h-screen bg-gray-50">
            <Sidebar />

            {/* Main Content */}
            <div className="flex min-w-0 flex-1 flex-col">
                <Header />

                {/* Main Content Area */}
                <main className="flex-1 p-4 sm:p-6 lg:p-8">{children}</main>
            </div>

            <BetaFeedbackWidget />
        </div>
    );
};

export default AppLayout;
